module.exports = __webpack_public_path__ + "static/img/contact.e9f0adc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/contact.png
// module id = PUbw
// module chunks = 0